<template>
  <v-card outlined :loading="loading">
    <v-card-title> General License Report </v-card-title>

    <v-divider />

    <v-card-text class="pa-10">
      <v-form ref="reportForm">
        <v-row>
          <v-col cols="12" md="6">
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formData.startDate"
                  label="Start Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                  :rules="rules.required"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="formData.startDate"
                @input="startDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="6">
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formData.endDate"
                  label="End Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                  :rules="rules.required"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="formData.endDate"
                @input="endDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-select
          dense
          outlined
          :items="memberTypes"
          v-model="formData.memberCategory"
          item-text="Description"
          item-value="Code"
          label="Member Category (Optional)"
          clearable
        />

        <v-select
          dense
          outlined
          :items="statusOptions"
          v-model="formData.status"
          label="Application Status (Optional)"
          clearable
        />

        <v-select
          dense
          outlined
          :items="['PDF', 'CSV']"
          v-model="formData.format"
          label="Export Format"
          :rules="rules.required"
        />
      </v-form>
    </v-card-text>

    <v-divider />

    <v-card-actions>
      <v-spacer />
      <v-btn text @click="toggleDialog"> Cancel</v-btn>

      <v-btn color="primary" @click="submit"> Export</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import validationMixin from "@/mixins/ValidationMixin";
import { eventBus } from "@/utils";
import { error } from "@/plugins/snack/snack";

export default {
  name: "LicenseReportForm",
  mixins: [validationMixin],
  props: ["toggleDialog"],
  data: function () {
    return {
      formData: {
        startDate: "",
        endDate: "",
        memberCategory: "",
        status: "",
        format: "PDF",
      },
      loading: false,
      title: "General License Report",
      icon: "mdi-file-chart", // Data property for the selector grid
      startDateMenu: false,
      endDateMenu: false,
      statusOptions: [
        "New",
        "Review",
        "Approved",
        "Released",
        "Rejected",
        "Onhold",
      ],
    };
  },

  computed: {
    memberTypes() {
      return this.$store.getters["Setup/memberType"];
    },
  },

  methods: {
    submit: function () {
      if (!this.$refs.reportForm.validate()) return;

      this.loading = true;

      this.$store
        .dispatch("License/generateReport", this.formData)
        .then((res) => {
          this.loading = false;
          if (res.data.data.file) {
            // Assuming API returns { file: "base64..." }
            eventBus.$emit("open-viewer", res.data.data.file);
            this.toggleDialog();
          } else {
            // Handle case where backend might return direct download link or raw data
            // For now, assuming base64 as per requirement "base64 string of a pdf"
            error("No file returned from server");
          }
        })
        .catch((err) => {
          this.loading = false;
          error(err.response?.data?.message || "Error generating report");
        });
    },
  },
};
</script>

<style scoped></style>
